import { defineObject } from '../define/use-define'
import { handleGetCheckOfficeNumber } from '@/lib/achievements/utils'

const katakanaToHiragana = (src: string) => {
  return src.replace(/[\u30a1-\u30f6]/g, (match: string) => {
    const chr = match.charCodeAt(0) - 0x60
    return String.fromCharCode(chr)
  })
}

const sortFunc = (firstElement: any, secondElement: any) => {
  const firstLastKana = katakanaToHiragana(firstElement.lastKana.toString())
  const secondLastKana = katakanaToHiragana(secondElement.lastKana.toString())
  if (firstLastKana < secondLastKana) return -1
  else if (firstLastKana > secondLastKana) return 1
  return 0
}

const sortAllFunc = (firstElement: any, secondElement: any) => {
  const firstLastKana = katakanaToHiragana(firstElement.cldKana.toString())
  const secondLastKana = katakanaToHiragana(secondElement.cldKana.toString())
  if (firstLastKana < secondLastKana) return -1
  else if (firstLastKana > secondLastKana) return 1
  return 0
}

const handleSortKana = (data: any) => {
  data.sort(sortFunc)
  return data
}

const handleSortAllKana = (data: any) => {
  data.sort(sortAllFunc)
  return data
}

const sortFuncToSnakeKeyChildKana = (firstElement: any, secondElement: any) => {
  const firstChildKana = katakanaToHiragana(
    firstElement['last_kana']
      ? firstElement['last_kana'].toString()
      : firstElement['child_kana'].toString()
  )
  const secondChildKana = katakanaToHiragana(
    secondElement['last_kana']
      ? secondElement['last_kana'].toString()
      : secondElement['child_kana'].toString()
  )
  if (firstChildKana < secondChildKana) return -1
  else if (firstChildKana > secondChildKana) return 1
  return 0
}

const handleSortToSnakeKeyChildKana = (data: any) => {
  data.sort(sortFuncToSnakeKeyChildKana)
  return data
}

export const handleSortSchoolYearChildData = (childData: any) => {
  const schoolYearGroupArray: any = []

  defineObject.AGE_AND_SCHOOL_OPTION_ARRAY.forEach(
    (schoolYear: { [key: string]: string }) => {
      let schoolYearGroup = childData.filter(
        (child: any) => child.schoolYear === schoolYear.value
      )

      schoolYearGroup = handleSortKana(schoolYearGroup)

      schoolYearGroupArray.push(...schoolYearGroup)
    }
  )

  return schoolYearGroupArray
}

export const handleSortBasicChildData = (childData: any) => {
  // 児童発達かつ在籍中の児童抽出
  const activeJihatsuSortData = childData.filter(
    (element: any) => element.affiliation === '1' && element.active === 1
  )

  handleSortSchoolYearChildData(activeJihatsuSortData)

  // 児童発達かつ在籍中の児童抽出(かなソート)
  const activeJihatsuKanaSortData = handleSortSchoolYearChildData(
    activeJihatsuSortData
  )

  // 放デイかつ在籍中の児童抽出
  const activeHoudaySortData = childData.filter(
    (element: any) => element.affiliation === '0' && element.active === 1
  )

  // 放デイかつ在籍中の児童抽出(かなソート)
  const activeHoudayKanaSortData = handleSortSchoolYearChildData(
    activeHoudaySortData
  )

  // 保訪かつ在籍中の児童抽出
  const activeVisitSortData = childData.filter(
    (element: any) => element.affiliation === '2' && element.active === 1
  )

  // 保訪かつ在籍中の児童抽出(かなソート)
  const activeVisitKanaSortData = handleSortSchoolYearChildData(
    activeVisitSortData
  )

  const acitiveConcatData = Array.prototype.concat(
    activeJihatsuKanaSortData,
    activeHoudayKanaSortData,
    activeVisitKanaSortData
  )

  // 児童発達かつ退所の児童抽出
  const noActiveJihatsuSortData = childData.filter(
    (element: any) => element.affiliation === '1' && element.active === 0
  )

  // 児童発達かつ退所の児童抽出(かなソート)
  const noActiveJihatsuKanaSortData = handleSortSchoolYearChildData(
    noActiveJihatsuSortData
  )

  // 放デイかつ退所の児童抽出
  const noActiveHoudaySortData = childData.filter(
    (element: any) => element.affiliation === '0' && element.active === 0
  )

  // 放デイかつ退所の児童抽出(かなソート)
  const noActiveHoudayKanaSortData = handleSortSchoolYearChildData(
    noActiveHoudaySortData
  )

  // 保訪かつ退所の児童抽出
  const noActiveVisitSortData = childData.filter(
    (element: any) => element.affiliation === '2' && element.active === 0
  )

  // 保訪かつ退所の児童抽出(かなソート)
  const noActiveVisitKanaSortData = handleSortSchoolYearChildData(
    noActiveVisitSortData
  )

  const noAcitiveConcatData = Array.prototype.concat(
    noActiveJihatsuKanaSortData,
    noActiveHoudayKanaSortData,
    noActiveVisitKanaSortData
  )

  // 所属をもつ児童(児発・在籍中(かなソート)→放デイ・在籍中(かなソート)→児発・退所(かなソート)→放デイ・退所(かなソート))
  const affiliationConcatData = Array.prototype.concat(
    acitiveConcatData,
    noAcitiveConcatData
  )

  return affiliationConcatData
}

type ISomeObject = {
  [key: string]: string
}

export const handleChangeKeyCamelSet = (data: any) => {
  const dataCamelKeyArray = data.map((ele: any) => {
    const obj: ISomeObject = {}
    Object.keys(ele).forEach((key: string) => {
      const camelKey = key.replace(/_./g, str => {
        return str.charAt(1).toUpperCase()
      })

      obj[camelKey] = ele[key]
    })
    return obj
  })

  return dataCamelKeyArray
}

export const handleGetStsUpperLimit = (childData: any, officeData: any) => {
  // 上限管理なし
  let res = 0

  const shapeCamelChildData = handleChangeKeyCamelSet([childData])[0]

  const shapeCamelOfficeData = handleChangeKeyCamelSet([officeData])[0]

  if (!shapeCamelChildData.upperLimit || !shapeCamelChildData.upperLimit['0']) {
    return res
  }

  const upperLimitOfficeNumber = handleGetCheckOfficeNumber(
    shapeCamelOfficeData.unitFlg,
    shapeCamelChildData.upperLimit['0'].office_number
  )

  const currentOfficeNumber = handleGetCheckOfficeNumber(
    shapeCamelOfficeData.unitFlg,
    shapeCamelOfficeData.officeNumber
  )

  if (upperLimitOfficeNumber === currentOfficeNumber) {
    // 上限管理自社
    res = 1
  } else {
    // 上限管理他社
    res = 2
  }

  return res
}

export const filterActiveAndNoActiveChildData = (
  childDataArray: { [key: string]: string | number | string[] | any }[]
) => {
  // 在籍中と退所の児童のみ抽出する
  childDataArray = childDataArray.filter(
    (data: { [key: string]: string | number | string[] | any }) =>
      data.active === 1 || data.active === 0
  )

  return childDataArray
}

export const handleSortClaimChildData = (
  data: any,
  checkAffiliationKey: string
) => {
  // 児童発達かつ在籍中の児童抽出
  const activeJihatsuSortData = data.filter(
    (element: any) =>
      element[checkAffiliationKey] === '1' && element.active === 1
  )

  // 児童発達かつ在籍中の児童抽出(かなソート)
  const activeJihatsuKanaSortData = handleSortKana(activeJihatsuSortData)

  // 放デイかつ在籍中の児童抽出
  const activeHoudaySortData = data.filter(
    (element: any) =>
      element[checkAffiliationKey] === '0' && element.active === 1
  )

  // 放デイかつ在籍中の児童抽出(かなソート)
  const activeHoudayKanaSortData = handleSortKana(activeHoudaySortData)

  // 保訪かつ在籍中の児童抽出
  const activeVisitSortData = data.filter(
    (element: any) =>
      element[checkAffiliationKey] === '2' && element.active === 1
  )

  // 保訪かつ在籍中の児童抽出(かなソート)
  const activeVisitKanaSortData = handleSortKana(activeVisitSortData)

  const acitiveConcatData = Array.prototype.concat(
    activeJihatsuKanaSortData,
    activeHoudayKanaSortData,
    activeVisitKanaSortData
  )

  // 児童発達かつ退所の児童抽出
  const noActiveJihatsuSortData = data.filter(
    (element: any) =>
      element[checkAffiliationKey] === '1' && element.active === 0
  )

  // 児童発達かつ退所の児童抽出(かなソート)
  const noActiveJihatsuKanaSortData = handleSortKana(noActiveJihatsuSortData)

  // 放デイかつ退所の児童抽出
  const noActiveHoudaySortData = data.filter(
    (element: any) =>
      element[checkAffiliationKey] === '0' && element.active === 0
  )

  // 放デイかつ退所の児童抽出(かなソート)
  const noActiveHoudayKanaSortData = handleSortKana(noActiveHoudaySortData)

  // 保訪かつ退所の児童抽出
  const noActiveVisitSortData = data.filter(
    (element: any) =>
      element[checkAffiliationKey] === '2' && element.active === 0
  )

  // 保訪かつ退所の児童抽出(かなソート)
  const noActiveVisitKanaSortData = handleSortKana(noActiveVisitSortData)

  const noAcitiveConcatData = Array.prototype.concat(
    noActiveJihatsuKanaSortData,
    noActiveHoudayKanaSortData,
    noActiveVisitKanaSortData
  )

  // 所属をもつ児童(児発・在籍中(かなソート)→放デイ・在籍中(かなソート)→児発・退所(かなソート)→放デイ・退所(かなソート))
  const affiliationConcatData = Array.prototype.concat(
    acitiveConcatData,
    noAcitiveConcatData
  )

  // 所属なしの在籍中の児童
  const activeNotAffiliation = data.filter(
    (element: any) => !element[checkAffiliationKey] && element.active === 1
  )

  const activeNotAffiliationKanaSortData = handleSortKana(activeNotAffiliation)

  // 所属なしの退所の児童
  const noActiveNotAffiliation = data.filter(
    (element: any) => !element[checkAffiliationKey] && element.active === 0
  )

  const noActiveNotAffiliationKanaSortData = handleSortKana(
    noActiveNotAffiliation
  )

  // 所属なし児童(在籍中(かなソート)→退所(かなソート))
  const notAffiliationConcatData = Array.prototype.concat(
    activeNotAffiliationKanaSortData,
    noActiveNotAffiliationKanaSortData
  )

  const concatChildData = Array.prototype.concat(
    affiliationConcatData,
    notAffiliationConcatData
  )

  return concatChildData
}

export const handleSortReBillingChildData = <T, S>(
  data: T[],
  checkAffiliationKey: S
) => {
  console.log(data)

  // 実績が児童発達の児童抽出
  let jihatsuAchivementsCldArray = data.filter(
    (element: any) => element[checkAffiliationKey] === '1'
  )

  jihatsuAchivementsCldArray = handleSortToSnakeKeyChildKana(
    jihatsuAchivementsCldArray
  )

  // 実績が放デイの児童抽出
  let houdayAchivementsCldArray = data.filter(
    (element: any) => element[checkAffiliationKey] === '0'
  )

  houdayAchivementsCldArray = handleSortToSnakeKeyChildKana(
    houdayAchivementsCldArray
  )

  // 実績が放デイの児童抽出
  let visitAchivementsCldArray = data.filter(
    (element: any) => element[checkAffiliationKey] === '2'
  )

  // 保訪
  visitAchivementsCldArray = handleSortToSnakeKeyChildKana(
    visitAchivementsCldArray
  )

  let notAchivementsCldArray = data.filter(
    (element: any) => !element[checkAffiliationKey]
  )

  notAchivementsCldArray = handleSortToSnakeKeyChildKana(notAchivementsCldArray)

  const concatChildData = Array.prototype.concat(
    jihatsuAchivementsCldArray,
    houdayAchivementsCldArray,
    visitAchivementsCldArray,
    notAchivementsCldArray
  )

  return concatChildData
}

const handleActiveSortDataCldList = (
  data: any,
  checkDataKey = 'achievements'
) => {
  const atFlgValueObjArray = defineObject.AT_FLG_VALUE_OBJ_ARRAY.map(
    (atFlgValueObj: { atFlg: number }) => {
      return {
        atFlg: atFlgValueObj.atFlg,
        array: [],
      }
    }
  ) as {
    atFlg: number
    array: any[]
  }[]

  let dataCldArray: any[] = atFlgValueObjArray.map(
    (activeObj: { atFlg: number; array: any[] }) => {
      const affiliationValueArray: any[] = defineObject.AFFILIATION_ARRAY.map(
        (affiliationObj: { value: string; text: string }) => {
          return [
            ...handleSortKana(
              data.filter(
                (cld: any) =>
                  cld[checkDataKey].flg === activeObj.atFlg &&
                  cld[checkDataKey].affiliation === affiliationObj.value
              )
            ),
          ]
        }
      )

      return [].concat(...affiliationValueArray)
    }
  )

  dataCldArray = [].concat(...dataCldArray)

  const notFlgValueArray: any[] = defineObject.AFFILIATION_ARRAY.map(
    (affiliationObj: { value: string; text: string }) => {
      return [
        ...handleSortKana(
          data.filter(
            (cld: any) =>
              (cld[checkDataKey].flg === '' ||
                cld[checkDataKey].flg === null ||
                cld[checkDataKey].flg === undefined) &&
              cld[checkDataKey].affiliation === affiliationObj.value
          )
        ),
      ]
    }
  )

  return dataCldArray.concat([].concat(...notFlgValueArray))
}

export const handleSortAchievementsCldList = (data: any) => {
  let achievementsDataCldArray = data.filter(
    (element: any) => element.achievements && !element.isAdd
  )

  achievementsDataCldArray = handleActiveSortDataCldList(
    achievementsDataCldArray
  )

  let achievementsNotDataCldArray = data.filter(
    (element: any) => !element.achievements && !element.isAdd
  )

  achievementsNotDataCldArray = handleActiveSortDataCldList(
    achievementsNotDataCldArray,
    'cld_book'
  )

  const achievementsAddDataCldArray = data.filter(
    (element: any) => element.isAdd
  )

  return achievementsNotDataCldArray.concat(
    achievementsDataCldArray,
    achievementsAddDataCldArray
  )
}

export const getActiveBadgeIconText = (status: number) => {
  const targetActive = defineObject.ACTIVE_ARRAY.find(
    (activeOption: { [key: string]: string | number }) =>
      activeOption.value === status
  )

  return targetActive ? String(targetActive.iconText) : ''
}

export const handleSortPickupChildData = (
  data: any,
  checkAffiliationKey: string
) => {
  // 児童発達かつ在籍中の児童抽出
  const activeJihatsuSortData = data.filter(
    (element: any) =>
      element[checkAffiliationKey].includes('1') && element.active === 1
  )

  // 児童発達かつ在籍中の児童抽出(かなソート)
  const activeJihatsuKanaSortData = handleSortAllKana(activeJihatsuSortData)

  // 放デイかつ在籍中の児童抽出
  const activeHoudaySortData = data.filter(
    (element: any) =>
      element[checkAffiliationKey].includes('0') && element.active === 1
  )

  // 放デイかつ在籍中の児童抽出(かなソート)
  const activeHoudayKanaSortData = handleSortAllKana(activeHoudaySortData)

  // 保訪かつ在籍中の児童抽出
  const activeVisitSortData = data.filter(
    (element: any) =>
      element[checkAffiliationKey].includes('2') && !(element[checkAffiliationKey].includes('0') || element[checkAffiliationKey].includes('1')) && element.active === 1
  )

  // 保訪かつ在籍中の児童抽出(かなソート)
  const activeVisitKanaSortData = handleSortAllKana(activeVisitSortData)

  const acitiveConcatData = Array.prototype.concat(
    activeJihatsuKanaSortData,
    activeHoudayKanaSortData,
    activeVisitKanaSortData
  )

  // 児童発達かつ退所の児童抽出
  // const noActiveJihatsuSortData = data.filter(
  //   (element: any) =>
  //     element[checkAffiliationKey].includes('1') && element.active === 0
  // )

  // // 児童発達かつ退所の児童抽出(かなソート)
  // const noActiveJihatsuKanaSortData = handleSortAllKana(noActiveJihatsuSortData)

  // // 放デイかつ退所の児童抽出
  // const noActiveHoudaySortData = data.filter(
  //   (element: any) =>
  //     element[checkAffiliationKey].includes('0') && element.active === 0
  // )

  // // 放デイかつ退所の児童抽出(かなソート)
  // const noActiveHoudayKanaSortData = handleSortAllKana(noActiveHoudaySortData)

  // // 保訪かつ退所の児童抽出
  // const noActiveVisitSortData = data.filter(
  //   (element: any) =>
  //     element[checkAffiliationKey].includes('2') && element.active === 0
  // )

  // // 保訪かつ退所の児童抽出(かなソート)
  // const noActiveVisitKanaSortData = handleSortAllKana(noActiveVisitSortData)

  // const noAcitiveConcatData = Array.prototype.concat(
  //   noActiveJihatsuKanaSortData,
  //   noActiveHoudayKanaSortData,
  //   noActiveVisitKanaSortData
  // )

  // 所属をもつ児童(児発・在籍中(かなソート)→放デイ・在籍中(かなソート)→児発・退所(かなソート)→放デイ・退所(かなソート))
  const affiliationConcatData = Array.prototype.concat(
    acitiveConcatData,
    // noAcitiveConcatData
  )

  // 所属なしの在籍中の児童
  const activeNotAffiliation = data.filter(
    (element: any) => !element[checkAffiliationKey] && element.active === 1
  )

  const activeNotAffiliationKanaSortData = handleSortAllKana(activeNotAffiliation)

  // 所属なしの退所の児童
  const noActiveNotAffiliation = data.filter(
    (element: any) => !element[checkAffiliationKey] && element.active === 0
  )

  const noActiveNotAffiliationKanaSortData = handleSortAllKana(
    noActiveNotAffiliation
  )

  // 所属なし児童(在籍中(かなソート)→退所(かなソート))
  const notAffiliationConcatData = Array.prototype.concat(
    activeNotAffiliationKanaSortData,
    noActiveNotAffiliationKanaSortData
  )

  const concatChildData = Array.prototype.concat(
    affiliationConcatData,
    notAffiliationConcatData
  )

  return concatChildData
}

